(function () {
  if (window.twoNuUnifiedMobileDockReady) return;
  window.twoNuUnifiedMobileDockReady = true;

  var root = document.documentElement;
  var body = document.body;
  var viewportState = {
    width: window.innerWidth || 0,
    height: window.innerHeight || 0,
    offsetLeft: 0,
    offsetTop: 0,
    pageLeft: window.pageXOffset || 0,
    pageTop: window.pageYOffset || 0
  };
  var ticking = false;

  function readViewport() {
    var visualViewport = window.visualViewport;
    var width = visualViewport ? visualViewport.width : window.innerWidth;
    var height = visualViewport ? visualViewport.height : window.innerHeight;
    var offsetLeft = visualViewport ? visualViewport.offsetLeft : 0;
    var offsetTop = visualViewport ? visualViewport.offsetTop : 0;
    var pageLeft = visualViewport && typeof visualViewport.pageLeft === 'number'
      ? visualViewport.pageLeft
      : (window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0);
    var pageTop = visualViewport && typeof visualViewport.pageTop === 'number'
      ? visualViewport.pageTop
      : (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0);

    viewportState = {
      width: Math.max(0, width || 0),
      height: Math.max(0, height || 0),
      offsetLeft: offsetLeft || 0,
      offsetTop: offsetTop || 0,
      pageLeft: pageLeft,
      pageTop: pageTop
    };

    root.style.setProperty('--two-nu-visual-viewport-width', viewportState.width + 'px');
    root.style.setProperty('--two-nu-visual-viewport-height', viewportState.height + 'px');
    root.style.setProperty('--two-nu-visual-viewport-offset-top', viewportState.offsetTop + 'px');
    root.style.setProperty('--two-nu-dock-mobile-center-y', (viewportState.offsetTop + viewportState.height / 2) + 'px');
    root.style.setProperty('--two-nu-dock-mobile-bottom-y', (viewportState.offsetTop + viewportState.height) + 'px');

    if (window.twoNuDockViewport && window.twoNuDockViewport.__twoNuUnified !== true) {
      window.twoNuDockViewport = createViewportApi();
    }

    window.dispatchEvent(new CustomEvent('twoNu:viewportchange', { detail: viewportState }));
  }

  function createViewportApi() {
    return {
      __twoNuUnified: true,
      getState: function () {
        return viewportState;
      },
      getScrollTop: function () {
        return Math.max(
          viewportState.pageTop || 0,
          window.scrollY || 0,
          document.documentElement.scrollTop || 0,
          document.body.scrollTop || 0
        );
      },
      refresh: readViewport
    };
  }

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function normalizePath(value) {
    try {
      var path = new URL(value, window.location.origin).pathname.toLowerCase();
      path = path.replace(/^\/(?:en|zh)(?:-[a-z0-9]+)*(?=\/|$)/, '') || '/';
      path = path.replace(/\/+$/, '') || '/';
      return path;
    } catch (error) {
      return '';
    }
  }

  function resolveHashTarget(hash) {
    if (!hash || hash.charAt(0) !== '#') return null;
    var id = hash.slice(1);
    if (!id) return null;

    try {
      id = decodeURIComponent(id);
    } catch (error) {}

    var target = document.getElementById(id);
    if (target) return target;

    try {
      return document.querySelector(hash);
    } catch (error) {
      return null;
    }
  }

  function resolveAnchorTarget(link, options) {
    if (!link) return null;

    options = options || {};
    var selectorAttribute = options.selectorAttribute || 'data-two-nu-dock-target-selector';
    var selector = link.getAttribute(selectorAttribute);

    if (!selector && selectorAttribute !== 'data-dock-target-selector') {
      selector = link.getAttribute('data-dock-target-selector');
    }

    if (!selector && selectorAttribute !== 'data-product-dock-target-selector') {
      selector = link.getAttribute('data-product-dock-target-selector');
    }

    if (selector) {
      try {
        return document.querySelector(selector);
      } catch (error) {
        return null;
      }
    }

    return resolveHashTarget(link.getAttribute('href'));
  }

  function markCurrentLinks(rootNode, options) {
    options = options || {};
    var rootNodeToUse = rootNode || document;
    var currentPath = normalizePath(window.location.href);
    if (!currentPath) return;

    var linkSelector = options.linkSelector || [
      '.two-nu-product-dock__menu-panel a[href]',
      '.two-nu-home-dock__menu-panel a[href]',
      '.two-nu-page-dock__menu-panel a[href]'
    ].join(',');

    rootNodeToUse.querySelectorAll(linkSelector).forEach(function (link) {
      var linkPath = normalizePath(link.getAttribute('href'));
      var isCurrent = linkPath === currentPath || (linkPath !== '/' && currentPath.indexOf(linkPath + '/') === 0);
      if (!isCurrent) return;
      link.setAttribute('aria-current', 'page');
      link.setAttribute('data-two-nu-dock-current', 'true');
    });
  }

  function markCurrentRegionButtons(rootNode, selector) {
    var rootNodeToUse = rootNode || document;
    rootNodeToUse.querySelectorAll(selector || '.two-nu-product-dock__region-item button.is-current, .two-nu-home-dock__region-item button.is-current, .two-nu-page-dock__region-item button.is-current').forEach(function (button) {
      button.setAttribute('aria-current', 'true');
      if (!button.getAttribute('aria-label')) {
        var currentOption = window.twoNuDockI18n && window.twoNuDockI18n.currentOption;
        button.setAttribute('aria-label', currentOption && window.twoNuInterpolate
          ? window.twoNuInterpolate(currentOption, { label: button.textContent.trim() })
          : button.textContent.trim());
      }
    });
  }

  function setActiveAnchor(links, activeLink) {
    Array.prototype.slice.call(links || []).forEach(function (link) {
      var isActive = link === activeLink;
      link.classList.toggle('is-active', isActive);
      if (isActive) {
        link.setAttribute('aria-current', 'location');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  }

  function positionPopover(trigger, popover, options) {
    if (!trigger || !popover) return;

    options = options || {};
    popover.hidden = false;

    var viewport = viewportState;
    var viewportLeft = viewport.offsetLeft || 0;
    var viewportTop = viewport.offsetTop || 0;
    var viewportWidth = viewport.width || window.innerWidth || 0;
    var viewportHeight = viewport.height || window.innerHeight || 0;
    var viewportRight = viewportLeft + viewportWidth;
    var viewportBottom = viewportTop + viewportHeight;
    var rect = trigger.getBoundingClientRect();
    var triggerRect = {
      left: rect.left + viewportLeft,
      right: rect.right + viewportLeft,
      top: rect.top + viewportTop,
      bottom: rect.bottom + viewportTop
    };
    var width = popover.offsetWidth || Math.min(options.defaultWidth || 330, viewportWidth - 28);
    var height = popover.offsetHeight || Math.min(options.defaultHeight || 520, viewportHeight - 20);
    var gap = options.gap || 9;
    var left;
    var top;

    if (viewportWidth <= (options.mobileBreakpoint || 920)) {
      left = triggerRect.left - width - gap;
      if (left < viewportLeft + 8) left = Math.max(viewportLeft + 8, viewportRight - width - 56);
      top = clamp(triggerRect.top, viewportTop + 8, Math.max(viewportTop + 8, viewportBottom - height - 8));
    } else {
      left = clamp(triggerRect.left, viewportLeft + 10, Math.max(viewportLeft + 10, viewportRight - width - 10));
      top = triggerRect.top - height - gap;
      if (top < viewportTop + 10) top = triggerRect.bottom + gap;
      top = clamp(top, viewportTop + 10, Math.max(viewportTop + 10, viewportBottom - height - 10));
    }

    popover.style.setProperty('--two-nu-popover-left', left + 'px');
    popover.style.setProperty('--two-nu-popover-top', top + 'px');
  }

  if (!window.twoNuDockViewport || typeof window.twoNuDockViewport.getState !== 'function') {
    window.twoNuDockViewport = createViewportApi();
  }

  function getScrollTop() {
    if (window.twoNuDockViewport && typeof window.twoNuDockViewport.getScrollTop === 'function') {
      return window.twoNuDockViewport.getScrollTop();
    }
    return Math.max(window.scrollY || 0, document.documentElement.scrollTop || 0, document.body.scrollTop || 0);
  }

  window.twoNuDockSystem = {
    version: '2026-05-17-phase-1',
    selectors: {
      productRoot: '[data-two-nu-product-dock]',
      homeRoot: '[data-two-nu-home-dock]',
      pageRoot: '.two-nu-page-dock',
      cartLink: '[data-two-nu-dock-cart-link]',
      feedback: '[data-two-nu-dock-feedback]'
    },
    clamp: clamp,
    getViewportState: function () {
      return viewportState;
    },
    getScrollTop: getScrollTop,
    markCurrentLinks: markCurrentLinks,
    markCurrentRegionButtons: markCurrentRegionButtons,
    normalizePath: normalizePath,
    positionPopover: positionPopover,
    resolveAnchorTarget: resolveAnchorTarget,
    setActiveAnchor: setActiveAnchor
  };

  function getHomeDockAnchors(dock) {
    return Array.prototype.slice.call(dock.querySelectorAll('.two-nu-home-dock__nav > a[data-dock-link], .two-nu-home-dock__nav > a[data-two-nu-dock-anchor]'));
  }

  function getPageDockAnchors(dock) {
    return Array.prototype.slice.call(dock.children).filter(function (child) {
      if (!child || child.tagName !== 'A') return false;
      if (child.classList.contains('two-nu-page-dock__icon')) return false;
      if (child.classList.contains('two-nu-page-dock__cart')) return false;
      if (child.classList.contains('two-nu-page-dock__whatsapp')) return false;
      return true;
    });
  }

  function getUnifiedDocks() {
    var docks = [];
    document.querySelectorAll('.two-nu-page-dock').forEach(function (dock) {
      docks.push({ dock: dock, anchors: getPageDockAnchors(dock) });
    });
    document.querySelectorAll('[data-two-nu-home-dock]').forEach(function (dock) {
      docks.push({ dock: dock, anchors: getHomeDockAnchors(dock) });
    });
    return docks.filter(function (item) {
      return item.anchors.length > 0;
    });
  }

  function clearAnchorPositions(items) {
    items.forEach(function (item) {
      item.anchors.forEach(function (anchor) {
        anchor.style.removeProperty('--two-nu-unified-anchor-top');
        anchor.removeAttribute('data-two-nu-unified-anchor');
      });
    });
  }

  function positionAnchors(items) {
    if (!items.length || viewportState.width > 749) {
      clearAnchorPositions(items);
      return;
    }

    var center = viewportState.offsetTop + viewportState.height / 2;
    items.forEach(function (item) {
      var anchors = item.anchors;
      var gap = 8;
      var heights = anchors.map(function (anchor) {
        anchor.setAttribute('data-two-nu-unified-anchor', 'true');
        return Math.max(44, Math.ceil(anchor.getBoundingClientRect().height || 44));
      });
      var total = heights.reduce(function (sum, height) {
        return sum + height;
      }, 0) + Math.max(0, anchors.length - 1) * gap;
      var top = Math.round(center - total / 2);

      anchors.forEach(function (anchor, index) {
        anchor.style.setProperty('--two-nu-unified-anchor-top', top + 'px');
        top += heights[index] + gap;
      });
    });
  }

  function updateBodyMode(items) {
    if (!body) body = document.body;
    if (!body) return;
    var hasUnifiedDock = items.length > 0;
    var hasProductDock = !!document.querySelector('[data-two-nu-product-dock]');
    body.classList.toggle('two-nu-unified-mobile-dock', hasUnifiedDock || hasProductDock);
    body.classList.toggle('two-nu-mobile-logo-compact', viewportState.width <= 749 && getScrollTop() > 42);
  }

  function update() {
    ticking = false;
    readViewport();
    var items = getUnifiedDocks();
    updateBodyMode(items);
    positionAnchors(items);
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  function bindBodyScroll() {
    if (!document.body || document.body.dataset.twoNuUnifiedBodyScroll === 'true') return;
    document.body.dataset.twoNuUnifiedBodyScroll = 'true';
    document.body.addEventListener('scroll', requestUpdate, { passive: true });
  }

  readViewport();
  bindBodyScroll();
  requestUpdate();
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  window.addEventListener('orientationchange', requestUpdate);
  window.addEventListener('pageshow', requestUpdate);
  document.addEventListener('shopify:section:load', function () {
    bindBodyScroll();
    requestUpdate();
  });
  document.addEventListener('shopify:section:unload', requestUpdate);

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', requestUpdate, { passive: true });
    window.visualViewport.addEventListener('scroll', requestUpdate, { passive: true });
  }
})();
/* TW language label now comes from the Shopify locale layer. */

/* CODEX_V1422_WAVE2_20260711_ACCESSIBILITY */
(function () {
        if (window.twoNuWave2AccessibilityReady) return;
        window.twoNuWave2AccessibilityReady = true;

        var dockTrigger = null;
        var popoverSelector = '[data-dock-popover], [data-two-nu-dock-popover], [data-product-dock-popover]';
        var triggerSelector = '[data-dock-control], [data-two-nu-dock-control], [data-product-dock-control]';
        var closeSelector = '[data-dock-close], [data-two-nu-dock-close], [data-product-dock-close]';
        var focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

        function isOpen(popover) {
          return popover && !popover.hidden && popover.getAttribute('aria-hidden') !== 'true';
        }

        function preparePopover(popover) {
          if (!popover) return;
          popover.setAttribute('role', 'dialog');
          popover.setAttribute('aria-modal', 'true');
          if (!popover.getAttribute('aria-label') && !popover.getAttribute('aria-labelledby')) {
            var heading = popover.querySelector('.two-nu-home-dock__popover-head span, .two-nu-page-dock__popover-head span, .two-nu-product-dock__popover-head span');
            if (heading && heading.textContent.trim()) popover.setAttribute('aria-label', heading.textContent.trim());
          }
        }

        function visiblePopover() {
          return Array.prototype.slice.call(document.querySelectorAll(popoverSelector)).reverse().find(isOpen) || null;
        }

        function focusables(popover) {
          return Array.prototype.slice.call(popover.querySelectorAll(focusableSelector)).filter(function (element) {
            return !element.hidden && element.getClientRects().length > 0;
          });
        }

        function closePopover(popover, restoreFocus) {
          if (!popover) return;
          var closeButton = popover.querySelector(closeSelector);
          if (closeButton) {
            closeButton.click();
            if (restoreFocus && dockTrigger && dockTrigger.isConnected) {
              window.requestAnimationFrame(function () {
                try { dockTrigger.focus({ preventScroll: true }); } catch (error) { dockTrigger.focus(); }
              });
            }
            return;
          }
          popover.classList.remove('is-open');
          popover.hidden = true;
          document.querySelectorAll(triggerSelector).forEach(function (trigger) {
            var controls = trigger.getAttribute('aria-controls') || trigger.getAttribute('data-two-nu-popover-target');
            if (!controls || controls === popover.id) trigger.setAttribute('aria-expanded', 'false');
          });
          if (restoreFocus && dockTrigger && dockTrigger.isConnected) {
            try { dockTrigger.focus({ preventScroll: true }); } catch (error) { dockTrigger.focus(); }
          }
        }

        function sanitizeJudgeMe(root) {
          var scope = root && root.querySelectorAll ? root : document;
          var mediaButtons = [];
          if (root && root.matches && root.matches('.jm-media-grid__item[aria-selected]')) mediaButtons.push(root);
          mediaButtons = mediaButtons.concat(Array.prototype.slice.call(scope.querySelectorAll('.jm-media-grid__item[aria-selected]')));
          mediaButtons.forEach(function (button) {
            button.setAttribute('aria-pressed', button.getAttribute('aria-selected') === 'true' ? 'true' : 'false');
            button.removeAttribute('aria-selected');
          });

          var tabs = [];
          if (root && root.matches && root.matches('.jdgm-tab[role="tab"][aria-controls]')) tabs.push(root);
          tabs = tabs.concat(Array.prototype.slice.call(scope.querySelectorAll('.jdgm-tab[role="tab"][aria-controls]')));
          tabs.forEach(function (tab) {
            var target = tab.getAttribute('aria-controls');
            if (target && !document.getElementById(target)) tab.removeAttribute('aria-controls');
          });
        }

        document.querySelectorAll(popoverSelector).forEach(preparePopover);
        sanitizeJudgeMe(document);

        document.addEventListener('click', function (event) {
          var trigger = event.target.closest(triggerSelector);
          if (trigger) {
            dockTrigger = trigger;
            window.requestAnimationFrame(function () {
              var popover = visiblePopover();
              if (!popover) return;
              preparePopover(popover);
              var items = focusables(popover);
              if (items.length) items[0].focus({ preventScroll: true });
            });
            return;
          }

          if (event.target.closest(closeSelector)) {
            var restore = dockTrigger;
            window.requestAnimationFrame(function () {
              if (!visiblePopover() && restore && restore.isConnected) restore.focus({ preventScroll: true });
            });
          }
        }, true);

        document.addEventListener('keydown', function (event) {
          var popover = visiblePopover();
          if (!popover) return;
          var items = focusables(popover);

          if (event.key === 'Escape') {
            event.preventDefault();
            event.stopImmediatePropagation();
            closePopover(popover, true);
            return;
          }

          if (event.key !== 'Tab' || !items.length) return;
          var first = items[0];
          var last = items[items.length - 1];
          if (!popover.contains(document.activeElement)) {
            event.preventDefault();
            first.focus();
          } else if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }, true);

        var queued = false;
        var observer = new MutationObserver(function (mutations) {
          if (queued) return;
          queued = true;
          window.requestAnimationFrame(function () {
            queued = false;
            mutations.forEach(function (mutation) {
              if (mutation.target instanceof Element) {
                preparePopover(mutation.target.matches(popoverSelector) ? mutation.target : null);
                sanitizeJudgeMe(mutation.target);
              }
              Array.prototype.forEach.call(mutation.addedNodes || [], function (node) {
                if (!(node instanceof Element)) return;
                if (node.matches(popoverSelector)) preparePopover(node);
                node.querySelectorAll(popoverSelector).forEach(preparePopover);
                sanitizeJudgeMe(node);
              });
            });
          });
        });
        observer.observe(document.body, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['aria-selected', 'aria-controls']
        });
      }());
/* CODEX_ACTIVITY_ANCHOR_SPY_20260721 */
(function () {
  'use strict';

  var marker = 'CODEX_ACTIVITY_ANCHOR_SPY_20260721';
  if (window.twoNuActivityDockSpy && window.twoNuActivityDockSpy.marker === marker) return;

  var activityPath = window.location.pathname.toLowerCase()
    .replace(/^\/(?:en|zh)(?:-[a-z0-9]+)*(?=\/|$)/, '')
    .replace(/\/+$/, '');
  var activityHandles = [
    '/collections/running',
    '/collections/hiking-sunglasses',
    '/collections/watersport',
    '/collections/fishing',
    '/collections/driving',
    '/collections/everyday'
  ];
  if (activityHandles.indexOf(activityPath) < 0) return;

  var dockSystem = window.twoNuDockSystem || null;
  if (!dockSystem || typeof dockSystem.setActiveAnchor !== 'function') return;

  var baseSetActiveAnchor = dockSystem.setActiveAnchor;
  var updateFrame = 0;
  var settleFrame = 0;
  var bodyBound = false;
  var clickTimers = [];
  var activeStateObserver = null;
  var clickLock = null;
  var clickLockArmTimer = 0;

  function pageAnchors(dock) {
    return Array.prototype.slice.call(dock ? dock.children : []).filter(function (node) {
      var href = node && node.getAttribute ? node.getAttribute('href') || '' : '';
      return node
        && node.tagName === 'A'
        && href.charAt(0) === '#'
        && !node.classList.contains('two-nu-page-dock__icon')
        && !node.classList.contains('two-nu-page-dock__cart')
        && !node.classList.contains('two-nu-page-dock__whatsapp');
    });
  }

  function safeQuery(selector) {
    if (!selector) return null;
    try {
      return document.querySelector(selector);
    } catch (error) {
      return null;
    }
  }

  function hrefTarget(link) {
    var href = link ? link.getAttribute('href') || '' : '';
    if (href.charAt(0) !== '#') return null;
    var id = href.slice(1);
    try {
      id = decodeURIComponent(id);
    } catch (error) {}
    return id ? document.getElementById(id) || safeQuery(href) : null;
  }

  function resolveTarget(link) {
    var selector = link.getAttribute('data-two-nu-dock-target-selector')
      || link.getAttribute('data-dock-target-selector')
      || link.getAttribute('data-product-dock-target-selector');
    return safeQuery(selector) || hrefTarget(link);
  }

  function scrollTop() {
    if (typeof dockSystem.getScrollTop === 'function') return dockSystem.getScrollTop();
    return Math.max(
      window.scrollY || 0,
      document.documentElement.scrollTop || 0,
      document.body ? document.body.scrollTop || 0 : 0
    );
  }

  function viewportHeight() {
    var state = typeof dockSystem.getViewportState === 'function'
      ? dockSystem.getViewportState()
      : null;
    return state && state.height ? state.height : window.innerHeight || 0;
  }

  function documentTop(target) {
    return target.getBoundingClientRect().top + scrollTop();
  }

  function compareTargetOrder(left, right) {
    if (left.target === right.target) return left.navIndex - right.navIndex;
    if (left.target.compareDocumentPosition && window.Node) {
      var position = left.target.compareDocumentPosition(right.target);
      if (position & window.Node.DOCUMENT_POSITION_FOLLOWING) return -1;
      if (position & window.Node.DOCUMENT_POSITION_PRECEDING) return 1;
    }
    return left.top === right.top ? left.navIndex - right.navIndex : left.top - right.top;
  }

  function reorderPageAnchors(dock, anchors, items) {
    if (anchors.length !== 4 || items.length !== anchors.length) return;
    var roles = anchors.map(function (link) {
      return link.getAttribute('data-two-nu-dock-role') || '';
    });
    var targets = items.map(function (item) { return item.target; });
    if (
      roles.some(function (role) { return !role; })
      || new Set(roles).size !== roles.length
      || new Set(targets).size !== targets.length
    ) return;

    var orderedLinks = items.slice().sort(compareTargetOrder).map(function (item) { return item.link; });
    var alreadyOrdered = anchors.every(function (link, index) { return link === orderedLinks[index]; });
    if (alreadyOrdered) return;

    var children = Array.prototype.slice.call(dock.children);
    var lastAnchorIndex = anchors.reduce(function (maximum, link) {
      return Math.max(maximum, children.indexOf(link));
    }, -1);
    var boundary = children[lastAnchorIndex + 1] || null;
    orderedLinks.forEach(function (link) {
      dock.insertBefore(link, boundary);
    });
  }

  function chooseActive(items) {
    if (clickLock && clickLock.link && clickLock.link.isConnected) {
      var lockedItem = items.find(function (item) { return item.link === clickLock.link; });
      if (lockedItem) return lockedItem;
    }

    var currentScroll = scrollTop();
    var height = viewportHeight();
    var documentHeight = Math.max(
      document.documentElement.scrollHeight || 0,
      document.body ? document.body.scrollHeight || 0 : 0
    );
    var atBottom = currentScroll + height >= documentHeight - Math.max(6, Math.round(height * 0.015));
    if (atBottom) return items[items.length - 1];

    var probe = currentScroll + height * 0.30;
    var active = items[0];
    items.forEach(function (item) {
      if (item.top <= probe + 1) active = item;
    });
    return active;
  }

  function activeIsCorrect(anchors, activeLink) {
    return anchors.every(function (link) {
      var shouldBeActive = link === activeLink;
      return link.classList.contains('is-active') === shouldBeActive
        && (link.getAttribute('aria-current') === 'location') === shouldBeActive;
    });
  }

  function updateDock(dock) {
    var anchors = pageAnchors(dock);
    var items = anchors.map(function (link, index) {
      var target = resolveTarget(link);
      return target ? { link: link, target: target, top: documentTop(target), navIndex: index } : null;
    }).filter(Boolean);

    if (!items.length) return;
    reorderPageAnchors(dock, anchors, items);
    items.sort(compareTargetOrder);
    var active = chooseActive(items);
    if (!activeIsCorrect(anchors, active.link)) baseSetActiveAnchor(anchors, active.link);
  }

  function updateAll() {
    document.querySelectorAll('.two-nu-page-dock').forEach(updateDock);
  }

  function requestUpdate() {
    if (updateFrame || settleFrame) return;
    updateFrame = window.requestAnimationFrame(function () {
      updateFrame = 0;
      settleFrame = window.requestAnimationFrame(function () {
        settleFrame = 0;
        updateAll();
      });
    });
  }

  function clearClickTimers() {
    clickTimers.forEach(window.clearTimeout);
    clickTimers = [];
  }

  function normalizeClickLock() {
    if (!clickLock || !clickLock.link || !clickLock.link.isConnected) return;
    var dock = clickLock.link.parentElement;
    var anchors = pageAnchors(dock);
    if (anchors.indexOf(clickLock.link) < 0) return;
    if (!activeIsCorrect(anchors, clickLock.link)) {
      baseSetActiveAnchor(anchors, clickLock.link);
    }
  }

  function settleAfterClick() {
    clearClickTimers();
    [0, 60, 180, 380, 620, 900].forEach(function (delay) {
      clickTimers.push(window.setTimeout(function () {
        normalizeClickLock();
        requestUpdate();
      }, delay));
    });
  }

  function setClickLock(link) {
    if (clickLockArmTimer) window.clearTimeout(clickLockArmTimer);
    clickLock = { link: link, armed: false, scrollTop: scrollTop() };
    clickLockArmTimer = window.setTimeout(function () {
      if (!clickLock || clickLock.link !== link) return;
      clickLock.armed = true;
      clickLock.scrollTop = scrollTop();
    }, 1400);
  }

  function releaseClickLock() {
    if (!clickLock) return;
    clickLock = null;
    if (clickLockArmTimer) window.clearTimeout(clickLockArmTimer);
    clickLockArmTimer = 0;
    requestUpdate();
  }

  function onScrollIntent() {
    releaseClickLock();
  }

  function onScrollKey(event) {
    if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].indexOf(event.key) >= 0) {
      releaseClickLock();
    }
  }

  function onWindowScroll() {
    if (
      clickLock
      && clickLock.armed
      && Math.abs(scrollTop() - clickLock.scrollTop) > 2
    ) {
      releaseClickLock();
    }
    requestUpdate();
  }

  function onPageAnchorClick(event) {
    var link = event.target && event.target.closest
      ? event.target.closest('.two-nu-page-dock > a[href^="#"]')
      : null;
    if (!link) return;
    var dock = link.parentElement;
    var anchors = pageAnchors(dock);
    if (anchors.indexOf(link) < 0) return;
    setClickLock(link);
    var target = resolveTarget(link);
    var nativeTarget = hrefTarget(link);
    if (target && target !== nativeTarget) {
      event.preventDefault();
      var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
      try {
        window.history.replaceState(null, '', link.getAttribute('href'));
      } catch (error) {}
    }
    baseSetActiveAnchor(anchors, link);
    settleAfterClick();
  }

  function bindBodyScroll() {
    if (bodyBound || !document.body) return;
    bodyBound = true;
    document.body.addEventListener('scroll', requestUpdate, { passive: true });
  }

  function bindActiveStateObserver() {
    if (activeStateObserver || !document.body || !window.MutationObserver) return;
    activeStateObserver = new MutationObserver(function (mutations) {
      var pageAnchorChanged = mutations.some(function (mutation) {
        var target = mutation.target;
        return target
          && target.tagName === 'A'
          && target.parentElement
          && target.parentElement.classList.contains('two-nu-page-dock');
      });
      if (pageAnchorChanged) {
        normalizeClickLock();
        requestUpdate();
      }
    });
    activeStateObserver.observe(document.body, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'aria-current']
    });
  }

  function init() {
    bindBodyScroll();
    bindActiveStateObserver();
    requestUpdate();
  }

  dockSystem.setActiveAnchor = function (links, activeLink) {
    baseSetActiveAnchor(links, activeLink);
    requestUpdate();
  };

  window.twoNuActivityDockSpy = {
    marker: marker,
    version: '2026-07-21-activity-collection-v4',
    refresh: requestUpdate,
    updateNow: updateAll,
    resolveTarget: resolveTarget
  };

  document.addEventListener('click', onPageAnchorClick, true);
  window.addEventListener('wheel', onScrollIntent, { passive: true });
  window.addEventListener('touchmove', onScrollIntent, { passive: true });
  window.addEventListener('keydown', onScrollKey);
  window.addEventListener('scroll', onWindowScroll, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  window.addEventListener('orientationchange', requestUpdate);
  window.addEventListener('pageshow', requestUpdate);
  window.addEventListener('twoNu:viewportchange', requestUpdate);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);
  document.addEventListener('shopify:section:unload', requestUpdate);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', requestUpdate, { passive: true });
    window.visualViewport.addEventListener('scroll', requestUpdate, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
